const EmptyChart = ({ text }: { text?: string }) => {
    return (
      <div className="empty text-center">
        <svg
          width="250"
          height="250"
          viewBox="0 0 250 250"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z"
            fill="#E1EAFA"
          />
          <path
            d="M200 249.999H50V88.3327C57.07 88.3247 63.8482 85.5127 68.8474 80.5135C73.8467 75.5142 76.6587 68.736 76.6667 61.666H173.333C173.326 65.1683 174.013 68.6373 175.355 71.8723C176.697 75.1073 178.667 78.0441 181.152 80.5127C183.62 82.9978 186.557 84.9687 189.792 86.311C193.028 87.6533 196.497 88.3404 200 88.3327V249.999Z"
            fill="white"
          />
          <path
            d="M125 170C147.091 170 165 152.091 165 130C165 107.909 147.091 90 125 90C102.909 90 85 107.909 85 130C85 152.091 102.909 170 125 170Z"
            fill="#2364D2"
          />
          <path
            d="M139.142 148.856L125 134.714L110.858 148.856L106.144 144.142L120.286 130L106.144 115.858L110.858 111.144L125 125.286L139.142 111.144L143.856 115.858L129.714 130L143.856 144.142L139.142 148.856Z"
            fill="white"
          />
          <path
            d="M146.667 180H103.334C100.573 180 98.334 182.239 98.334 185C98.334 187.761 100.573 190 103.334 190H146.667C149.429 190 151.667 187.761 151.667 185C151.667 182.239 149.429 180 146.667 180Z"
            fill="#E1EAFA"
          />
          <path
            d="M161.667 200H88.334C85.5726 200 83.334 202.239 83.334 205C83.334 207.761 85.5726 210 88.334 210H161.667C164.429 210 166.667 207.761 166.667 205C166.667 202.239 164.429 200 161.667 200Z"
            fill="#E1EAFA"
          />
        </svg>
        {!!text && <p>{text}</p>}
      </div>
    );
  };
  export default EmptyChart;
  